import React, { useState } from 'react';
import {
  Button,
  Confirm,
  Dropdown,
  Form,
  Icon,
  Input,
  Modal,
  Popup,
  Table
} from 'semantic-ui-react';
import axios from 'axios';

import { useError } from '../providers';

const ChannelPoint = ({ redeem, commands, refresh }) => {
  const { showError } = useError();

  const calcIntMod = () => {
    if (globalCooldown === 0) {
      return 1;
    }

    if (globalCooldown % 1440 === 0) {
      setGlobalCooldown(globalCooldown / 1440);
      return 1440;
    }
    if (globalCooldown % 60 === 0) {
      setGlobalCooldown(globalCooldown / 60);
      return 60;
    }

    return 1;
  }

  const [open, setOpen] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [name, setName] = useState(redeem ? redeem.name || '' : '');
  const [description, setDescription] = useState(redeem ? redeem.description || '' : '');
  const [cost, setCost] = useState(redeem ? redeem.cost || '' : '');
  const [command, setCommand] = useState(redeem ? redeem.command || '' : '');
  const [params, setParams] = useState(redeem ? redeem.params || '' : '');
  const [inputRequired, setInputRequired] = useState(redeem ? redeem.input_required || false : false);
  const [maxPerStream, setMaxPerStream] = useState(redeem ? redeem.max_per_stream || 0 : 0);
  const [maxPerUserPerStream, setMaxPerUserPerStream] = useState(redeem ? redeem.max_per_user_per_stream || 0 : 0);
  const [globalCooldown, setGlobalCooldown] = useState(redeem ? redeem.global_cooldown || 0 : 0);
  const [intMod, setIntMod] = useState(calcIntMod());
  const [enabled, setEnabled] = useState(redeem ? redeem.enabled : true);
  const [autoCleanup, setAutoCleanup] = useState(redeem ? redeem.auto_cleanup : true);
  const [autoRedeem, setAutoRedeem] = useState(redeem ? redeem.auto_redeem : true);
  const [saving, setSaving] = useState(false);

  const intervals = [
    { key: 'minutes', text: 'minutes', value: 1 },
    { key: 'hours', text: 'hours', value: 60 },
    { key: 'days', text: 'days', value: 1440 },
  ]

  const saveRedeem = async () => {
    const payload = {
      max_per_stream: parseInt(maxPerStream, 10),
      max_per_user_per_stream: parseInt(maxPerUserPerStream, 10),
      global_cooldown: parseInt(globalCooldown * intMod, 10),
      input_required: inputRequired,
      cost: parseInt(cost, 10),
      auto_redeem: autoRedeem,
      auto_cleanup: autoCleanup,
      name,
      description,
      command,
      params,
      enabled,
    }

    if (redeem) {
      payload.id = redeem.id;
    }

    try {
      const { data } = await axios.post(
        '/api/channelpoints',
        payload,
      );

      setSaving(false);

      switch (data.status) {
        case 200: // Save was successful.
          setOpen(false);
          refresh();
          break;
        default:  // Anything else
          showError(<center>An unknown error occured while trying to save your changes.</center>);
          break;
      }
    } catch (err) {
      showError(<center>An unknown error occured while trying to save your changes.</center>);
      setSaving(false);
    }
  }

  const testRedeem = async () => {
    setSaving(true);

    const payload = {
      max_per_stream: parseInt(maxPerStream, 10),
      max_per_user_per_stream: parseInt(maxPerUserPerStream, 10),
      global_cooldown: parseInt(globalCooldown * intMod, 10),
      input_required: inputRequired,
      cost: parseInt(cost, 10),
      auto_redeem: autoRedeem,
      auto_cleanup: autoCleanup,
      name,
      description,
      command,
      params,
      enabled,
    }

    if (redeem) {
      payload.name = name + '_t' + Date.now();
    }

    try {
      const { data } = await axios.post(
        '/api/channelpoints/test',
        payload,
      );

      console.log(data.status, data.response);

      switch (data.status) {
        case 200: // Test was successful
          saveRedeem();
          break;
        default:  // Anything else
          showError(<center>{typeof data.response.message != 'string' ? JSON.stringify(data.response.message) : data.response.message}</center>);
          setSaving(false);
          break;
      }
    } catch (err) {
      showError(<center>An unknown error occured while trying to test your Channel Point redeem.</center>);
      setSaving(false);
    }
  }

  const deleteRedeem = async () => {
    setConfirmation(false);

    const payload = {
      id: redeem.id,
    }

    try {
      const { data } = await axios.post(
        '/api/channelpoints/delete',
        payload,
      );

      switch (data.status) {
        case 200:
          refresh();
          break;
        default:
          showError(<center>There was an error deleting the specified Channel Point redeem.</center>);
          break;
      }
    } catch (err) {
      showError(<center>An unknown error occured while trying to test your Channel Point redeem.</center>);
    }
  }

  return (
    <Modal
      onClose={() => { setOpen(false); refresh(); }}
      onOpen={() => setOpen(true)}
      open={open}
      closeOnDimmerClick={false}
      trigger={redeem ?
        <Button icon>
          <Icon name='edit' />
        </Button>
        :
        <Button icon labelPosition='left'>
          <Icon name='plus' /> Add New Channel Point Redeem
        </Button>
      }
    >
      <Modal.Header>{redeem ? 'Edit' : 'Create'} Channel Point Redeem</Modal.Header>
      <Modal.Content>
        <Table basic='very' inverted>
          <Table.Body>
            <Table.Row>
              <Table.Cell colspan={6}>
                <Form inverted>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <label>
                        Name
                      </label>
                      <Input
                        fluid
                        maxLength={45}
                        value={name}
                        onChange={(ev) => setName(ev.target.value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Channel Point Cost</label>
                      <Input
                        fluid
                        type='number'
                        min={1}
                        value={cost}
                        onChange={(ev) => setCost(ev.target.value)}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Field>
                    <label>Incentive Description</label>
                    <Input
                      fluid
                      maxLength={168}
                      value={description}
                      onChange={(ev) => setDescription(ev.target.value)}
                    />
                  </Form.Field>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <label>
                        Action
                        &nbsp;
                        <Popup
                          content="The action that should be executed when redeemed with channel points. This can be global or user created commands."
                          position='right center'
                          trigger={<Icon size='small' color='grey' name='help circle' />}
                        />
                      </label>
                      <Dropdown
                        selection
                        fluid
                        options={commands}
                        value={command}
                        data-field='command'
                        onChange={(ev, { value }) => setCommand(value)}
                        placeholder='Select an Action'
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>
                        Action Parameters (optional)
                        &nbsp;
                        <Popup
                          content='Optional parameters to pass to the command, as if it were typed in chat; example: "!give brimstone" would expect "brimstone" to be entered in this field.'
                          position='right center'
                          trigger={<Icon size='small' color='grey' name='help circle' />}
                        />
                      </label>
                      <Input
                        fluid
                        value={params}
                        onChange={(ev) => setParams(ev.target.value)}
                        disabled={inputRequired}
                      />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <strong>Allow User Input</strong>{' '}
                <Popup
                  content='Allow users to enter command parameters when redeeming; example: "!friend" can be executed with the user input of "ultra greedier" to allow users to specify their friend with channel points.'
                  position='right center'
                  trigger={<Icon size='small' color='grey' name='help circle' />}
                />
              </Table.Cell>
              <Table.Cell>
                <Form.Checkbox toggle checked={inputRequired} onChange={(ev, data) => setInputRequired(data.checked)} />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell colspan={6}>
                <Form inverted>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <label>
                        Total Redemption Limit Per Stream{' '}
                        <Popup
                          content='Maximum amount of times this can be redeemed per stream by all users. Use 0 to disable limits.'
                          position='right center'
                          trigger={<Icon size='small' color='grey' name='help circle' />}
                        />
                      </label>
                      <Input
                        fluid
                        type='number'
                        min={0}
                        value={maxPerStream}
                        onChange={(ev) => setMaxPerStream(ev.target.value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>
                        Redemption Limit Per User Per Stream{' '}
                        <Popup
                          content='Maximum amount of times this can be redeemed per user each stream. Use 0 to disable limits.'
                          position='right center'
                          trigger={<Icon size='small' color='grey' name='help circle' />}
                        />
                      </label>
                      <Input
                        fluid
                        type='number'
                        min={0}
                        value={maxPerUserPerStream}
                        onChange={(ev) => setMaxPerUserPerStream(ev.target.value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>
                        Redemption Cooldown{' '}
                        <Popup
                          content='The ammount of time before this can be redeemed by any user again. Use 0 to disable.'
                          position='right center'
                          trigger={<Icon size='small' color='grey' name='help circle' />}
                        />
                      </label>
                      <Input
                        style={{ width: '75px' }}
                        type='number'
                        min={0}
                        value={globalCooldown}
                        onChange={(ev) => setGlobalCooldown(ev.target.value)}
                      />{'  '}
                      <Dropdown
                        upward
                        floating
                        inline
                        options={intervals}
                        defaultValue={intMod}
                        onChange={(ev, { value }) => setIntMod(value)}
                      />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <strong>
                  Enabled{' '}
                  <Popup
                    content='Enables or disables creation of the Channel Point - when disabled, it will not auto-create when signing in to the mod.'
                    position='right center'
                    trigger={<Icon size='small' color='grey' name='help circle' />}
                  />
                </strong>
              </Table.Cell>
              <Table.Cell>
                <Form.Checkbox toggle checked={enabled} onChange={(ev, data) => setEnabled(data.checked)} />
              </Table.Cell>
              <Table.Cell collapsing>
                <strong>
                  Auto-CleanUp{' '}
                  <Popup
                    content='When enabled, this Channel Point will automatically remove itself from Twitch when you log out of the mod.'
                    position='right center'
                    trigger={<Icon size='small' color='grey' name='help circle' />}
                  />
                </strong>
              </Table.Cell>
              <Table.Cell>
                <Form.Checkbox toggle checked={autoCleanup} onChange={(ev, data) => setAutoCleanup(data.checked)} />
              </Table.Cell>
              <Table.Cell collapsing>
                <strong>
                  Auto-Redeem{' '}
                  <Popup
                    content='When enabled, redeems for this Channel Point will automatically be marked as redeemed.'
                    position='right center'
                    trigger={<Icon size='small' color='grey' name='help circle' />}
                  />
                </strong>
              </Table.Cell>
              <Table.Cell>
                <Form.Checkbox toggle checked={autoRedeem} onChange={(ev, data) => setAutoRedeem(data.checked)} />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        {redeem ?
          <div>
            <Button style={{ float: 'left' }} color='red' onClick={() => setConfirmation(true)}>
              Delete
            </Button>
            <Confirm
              open={confirmation}
              onCancel={() => setConfirmation(false)}
              onConfirm={() => deleteRedeem()}
            />
          </div>
          : ''}
        <Button color='black' onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button color='green' enabled={!saving} loading={saving} onClick={() => testRedeem()}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  )
};

export default ChannelPoint;
